import React from 'react';
import styles from './SysListing.module.css';

interface SysBadgeProps {
  tone: string;
  children: React.ReactNode;
}

const SysBadge: React.FC<SysBadgeProps> = ({ tone, children }) => (
  <span className={`${styles.badge} ${styles[`badge-${tone}`] || ''}`.trim()}>
    {children}
  </span>
);

export default SysBadge;
